<form [formGroup]="stepForm">
  <div class="mat-flex ">
    <mat-form-field>
      <mat-label>Coluna - Fileira</mat-label>
      <mat-select formControlName="seat">
        <mat-option *ngFor="let seat of seats.flat()"
                    [value]="seat"
                    (onSelectionChange)="onSelect(seat, $event)"
                    [disabled]="seat.priority || disabled">
          {{ seat.row  + ' - ' + seat.column }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Tipo de Assento</mat-label>
      <mat-select formControlName="type">
        <mat-option *ngFor="let type of typesSelect"
                    [value]="type.value"
                    (onSelectionChange)="onSelectType(index!, type.value, $event)" [disabled]="disabled">
          {{ type.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-button
            class="btn-action primary-color"
            (click)="onRemove(index!)"
            *ngIf="!disabled">
      <img src="../../../../../assets/icons/lixeira2.svg" />
    </button>
  </div>
</form>
